import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTheme } from '../contexts/ThemeContext';

const ToggleContainer = styled.div`
  position: fixed;
  top: 100px;
  right: 20px;
  z-index: 999;
  background: ${props => props.theme.colors.surface};
  border: 2px solid ${props => props.theme.colors.border};
  border-radius: 12px;
  padding: 0.75rem 1rem;
  box-shadow: 0 4px 20px ${props => props.theme.colors.shadow};
  backdrop-filter: blur(10px);
  
  @media (max-width: 768px) {
    top: 80px;
    right: 10px;
    padding: 0.5rem 0.75rem;
  }
`;

const Label = styled.div`
  font-size: 0.75rem;
  font-weight: 600;
  color: ${props => props.theme.colors.textSecondary};
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  
  @media (max-width: 768px) {
    font-size: 0.7rem;
  }
`;

const ToggleButton = styled.button`
  background: ${props => props.isPrivate 
    ? 'linear-gradient(45deg, #ff6b6b, #ee5a6f)'
    : 'linear-gradient(45deg, #51cf66, #37b24d)'
  };
  color: white;
  border: none;
  border-radius: 8px;
  padding: 0.5rem 1rem;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  }
  
  &:active {
    transform: translateY(0);
  }
  
  @media (max-width: 768px) {
    font-size: 0.75rem;
    padding: 0.4rem 0.8rem;
  }
`;

const Icon = styled.span`
  font-size: 1rem;
`;

const DatasetToggle = ({ isPrivate, onToggle }) => {
  const { themeData } = useTheme();
  
  // Only show in development
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }
  
  return (
    <ToggleContainer theme={themeData}>
      <Label theme={themeData}>Dev Mode</Label>
      <ToggleButton 
        isPrivate={isPrivate}
        onClick={onToggle}
        theme={themeData}
      >
        <Icon>{isPrivate ? '🔓' : '🔒'}</Icon>
        {isPrivate ? 'Private' : 'Public'}
      </ToggleButton>
    </ToggleContainer>
  );
};

DatasetToggle.propTypes = {
  isPrivate: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired
};

export default DatasetToggle;

